import { Box, HStack } from '@chakra-ui/core';
import React, { useState } from 'react';
import { ImagePreviewModal } from '../../../../../app/components/ImagePreviewModal';
import ImageView from '../../../../../app/components/ImageView';
import { GalleryImageType } from '../../../imageGallery/ImageGalleryType';

const QuestionImages: React.FC<{ images?: GalleryImageType[] }> = ({ images }) => {
  const [open, setOpen] = useState(false);

  if (!images?.length) return null;

  return (
    <HStack data-testid="question-images" spacing={3} mb={2} justify="flex-start">
      {images.map((img) => (
        <Box key={img.url} cursor="pointer">
          <ImageView src={img.url} height={40} shape="rounded" showAddImageIcon={false} onClick={() => setOpen(true)} />
        </Box>
      ))}

      {images.length > 0 && (
        <ImagePreviewModal
          setTrigger={open}
          images={images}
          getImageKey={(image) => image?.id || ''}
          getImageSrc={(image) => image?.url || ''}
          onModalClose={() => setOpen(false)}
        />
      )}
    </HStack>
  );
};

export default QuestionImages;
